<template>
  <ul class="pcoded-item pcoded-left-item sidebar-scroll">
    <!-- <li class="" v-bind:class="{'active': selected == 'dashboard'}">
            <a href="/dashboard" v-on:click="select('dashboard')">
                <span class="pcoded-micon"><i class="ti-dashboard"></i><b>D</b></span>
                <span class="pcoded-mtext" data-i18n="nav.dash.main">Dashboard</span>
                <span class="pcoded-mcaret"></span>
            </a>
        </li> -->

    <li
      v-if="$checkPerm('report.view')"
      class="pcoded-hasmenu"
      v-bind:class="{ 'active, pcoded-trigger': selected == 'dashboard' }"
      dropdown-icon="style1"
      subitem-icon="style6"
    >
      <a href="javascript:void(0)" v-on:click="select('dashboard')">
        <span class="pcoded-micon"><i class="ti-dashboard"></i><b>D</b></span>
        <span class="pcoded-mtext" data-i18n="nav.page_layout.main"
          >Dashboards</span
        >
        <span class="pcoded-mcaret"></span>
      </a>

      <ul class="pcoded-submenu">
        <li class="">
          <a href="/dashboard">
            <span class="pcoded-micon"><i class="icon-pie-chart"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.bottom-menu"
              >Default Dashboard</span
            >
          </a>
        </li>

        <li class="">
          <a href="/recruitmentdashboard">
            <span class="pcoded-micon"><i class="icon-pie-chart"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.box-layout"
              >Recruitment Dashboard</span
            >
          </a>
        </li>
      </ul>
    </li>

    <li
      class="pcoded-hasmenu"
      v-bind:class="{ 'active, pcoded-trigger': selected == 'openings' }"
      dropdown-icon="style1"
      subitem-icon="style6"
    >
      <a href="javascript:void(0)" v-on:click="select('openings')">
        <span class="pcoded-micon"><i class="ti-layout"></i><b>O</b></span>
        <span class="pcoded-mtext" data-i18n="nav.page_layout.main"
          >Openings and Applications</span
        >
        <span class="pcoded-mcaret"></span>
      </a>

      <ul class="pcoded-submenu">
        <li class="">
          <a href="/openings">
            <span class="pcoded-micon"><i class="icon-pie-chart"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.bottom-menu"
              >All Openings</span
            >
          </a>
        </li>

        <li v-if="$checkPerm('opening.create')" class="">
          <a href="/openings/new">
            <span class="pcoded-micon"><i class="icon-pie-chart"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.box-layout"
              >Create New Opening</span
            >
          </a>
        </li>

        <li v-if="$checkPerm('archived_applications.view')" class="">
          <a href="/applications/starred">
            <span class="pcoded-micon"><i class="icon-star"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.box-layout"
              >Archived Applications</span
            >
          </a>
        </li>

        <li v-if="$checkPerm('application.discontinue')" class="">
          <a href="/applications/discontinued">
            <span class="pcoded-micon"><i class="icon-star"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.box-layout"
              >Discontinued Applications</span
            >
          </a>
        </li>
      </ul>
    </li>

    <li
      v-if="
        $checkPerm('process.cbt.view') ||
        $checkPerm('process.video_instructions.view')
      "
      class="pcoded-hasmenu"
      v-bind:class="{ 'active, pcoded-trigger': selected == 'stages' }"
      dropdown-icon="style1"
      subitem-icon="style6"
    >
      <a href="javascript:void(0)" v-on:click="select('stages')">
        <span class="pcoded-micon"><i class="ti-bar-chart"></i><b>S&P</b></span>
        <span class="pcoded-mtext" data-i18n="nav.page_layout.main"
          >Stages &amp; Processes</span
        >
        <!-- <span class="pcoded-badge label label-warning">NEW</span> -->
        <span class="pcoded-mcaret"></span>
      </a>

      <ul class="pcoded-submenu">
        <li v-if="$checkPerm('process.create')" class="">
          <a href="/stages" v-on:click="select('stages')">
            <span class="pcoded-micon"><i class="ti-bar-chart"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.bottom-menu"
              >Processes</span
            >
          </a>
        </li>

        <li v-if="$checkPerm('process.cbt.view')" class="">
          <a href="/cbt" v-on:click="select('stages')">
            <span class="pcoded-micon"><i class="ti-desktop"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.box-layout"
              >Computer Based Test</span
            >
          </a>
        </li>

        <li v-if="$checkPerm('process.video_instructions.view')" class="">
          <a href="/video" v-on:click="select('stages')">
            <span class="pcoded-micon"><i class="ti-video-camera"></i></span>
            <span class="pcoded-mtext" data-i18n="nav.page_layout.box-layout"
              >Video Upload</span
            >
          </a>
        </li>
      </ul>
    </li>

    <li
      v-if="$checkPerm('application.send_email')"
      class=""
      v-bind:class="{ active: selected == 'email' }"
    >
      <a href="/email" v-on:click="select('email')">
        <span class="pcoded-micon"
          ><i class="icofont icofont-at"></i><b>S</b></span
        >
        <span class="pcoded-mtext" data-i18n="nav.dash.main">Email</span>
        <span class="pcoded-mcaret"></span>
      </a>
    </li>

    <li
      class="pcoded-hasmenu"
      v-if="$checkPerm('offer_template.view') || $checkPerm('scorecard.view')"
      v-bind:class="{ 'active, pcoded-trigger': selected == 'utilities' }"
      dropdown-icon="style1"
      subitem-icon="style6"
    >
      <a href="javascript:void(0)" v-on:click="select('utilities')">
        <span class="pcoded-micon"
          ><i class="icofont icofont-repair"></i><b>U</b></span
        >
        <span class="pcoded-mtext" data-i18n="nav.page_layout.main"
          >Utilities</span
        >
        <!-- <span class="pcoded-badge label label-warning">NEW</span> -->
        <span class="pcoded-mcaret"></span>
      </a>
      <ul class="pcoded-submenu">
        <li
          v-if="$checkPerm('offer_template.view')"
          class=""
          v-bind:class="{ active: selected == 'offertemplates' }"
        >
          <a href="/offertemplates" v-on:click="select('offertemplates')">
            <span class="pcoded-micon"
              ><i class="icofont icofont-pen-alt-4"></i><b>S</b></span
            >
            <span class="pcoded-mtext" data-i18n="nav.dash.main"
              >Offer Templates</span
            >
            <span class="pcoded-mcaret"></span>
          </a>
        </li>

        <li
          v-if="$checkPerm('scorecard.view')"
          class=""
          v-bind:class="{ active: selected == 'scorecard' }"
        >
          <a href="/scorecard" v-on:click="select('scorecard')">
            <span class="pcoded-micon"
              ><i class="icofont icofont-at"></i><b>S</b></span
            >
            <span class="pcoded-mtext" data-i18n="nav.dash.main"
              >ScoreCard</span
            >
            <span class="pcoded-mcaret"></span>
          </a>
        </li>
      </ul>
    </li>

    <li
      v-if="$checkPerm('users.create')"
      class="pcoded-hasmenu"
      v-bind:class="{ 'active, pcoded-trigger': selected == 'users' }"
      dropdown-icon="style1"
      subitem-icon="style6"
    >
      <a href="javascript:void(0)" v-on:click="select('users')">
        <span class="pcoded-micon"
          ><i class="icofont icofont-user"></i><b>SU</b></span
        >
        <span class="pcoded-mtext" data-i18n="nav.page_layout.main"
          >System Users</span
        >
        <!-- <span class="pcoded-badge label label-warning">NEW</span> -->
        <span class="pcoded-mcaret"></span>
      </a>
      <ul class="pcoded-submenu">
        <li
          v-if="$checkPerm('roles.create')"
          class=""
          v-bind:class="{ active: selected == 'roles' }"
        >
          <a href="/roles" v-on:click="select('roles')">
            <span class="pcoded-micon"
              ><i class="icofont icofont-pen-alt-4"></i><b>S</b></span
            >
            <span class="pcoded-mtext" data-i18n="nav.dash.main"
              >Roles and Permission</span
            >
            <span class="pcoded-mcaret"></span>
          </a>
        </li>

        <li
          v-if="$checkPerm('users.create')"
          class=""
          v-bind:class="{ active: selected == 'users' }"
        >
          <a href="/users" v-on:click="select('users')">
            <span class="pcoded-micon"
              ><i class="icofont icofont-at"></i><b>S</b></span
            >
            <span class="pcoded-mtext" data-i18n="nav.dash.main">Users</span>
            <span class="pcoded-mcaret"></span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>
<style type="text/css">
.widget-card-1 .card1-icon {
  width: 30px !important;
  height: 30px !important;
  font-size: 20px !important;
}
.sidebar-scroll {
  max-height: 100vh;
  overflow-y: auto;
  height: 100vh;
}

/* Scoped scrollbar styles */
.sidebar-scroll::-webkit-scrollbar {
  width: 6px;
  height: 2px;
}

.sidebar-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.sidebar-scroll::-webkit-scrollbar-thumb {
  background: #9ca3af;
  border-radius: 5px;
}
</style>

<style type="text/css">
.widget-card-1 .card1-icon {
  width: 30px !important;
  height: 30px !important;
  font-size: 20px !important;
}
</style>
<script>
import "@/assets/js/jquery.min.js";
// pcoded-trigger
export default {
  name: "Menu",
  data() {
    return {
      role: "",
      selected: localStorage.getItem("selected"),
    };
  },
  mounted() {
    var user = this.$store.getters.user_data;
  },
  methods: {
    select(what) {
      localStorage.setItem("selected", what);
    },
  },
};
</script>